import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ConfigService} from '../config/config-service';
import { SessionService } from './session.service';
import { environment } from '../../environments/environment';

@Injectable()
export class FelectronicaService {
	private config: ConfigService;
	private _token: any;
	private host_api: String;
	private dbname: string;
	public factelec_api: String;

	constructor(
		private http: Http,
		private ss: SessionService
	) {
		this.config = new ConfigService();
		this.host_api = this.ss.getData('host_api');
		this._token = sessionStorage.getItem('api-token');
		this.dbname = this.ss.getData('dbname');
		this.factelec_api = environment.factelec_api;
	}

	ReenviarElectronica(documento) {
		let url = this.factelec_api + '/' + this.ss.getData('fact_user') + '/correo';
		let params = documento;
		let headers = new Headers({'Content-type': 'application/json'});
		headers.append('Authorization', "Bearer " + this.ss.getData('fact-api-token'));

		let options = new RequestOptions({ headers: headers });

		return this.http.post(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/services/felectronica.service.ts